import { Title } from '../../Typography';

const TopicTitle = ({ title }: { title: string }) => (
  <Title tag="div" type="xxs">
    {title}
  </Title>
);

export default TopicTitle;
